<template>
  <div class="columns email-and-sms-section">
    <!-- Text Section Begins -->
    <div class="column is-6 padding-left-0 is-block text-section">
      <span class="update-class-text">Update your templates</span>
      <!-- Review Invites Section Begins -->
      <div class="review-invite-section" :class="[{'padding-bottom': accordion.reviewInvites.show}]">
        <div class="column is-flex flex-align-centre is-full is-paddingless" @click="preparePreview('reviewInvites')">
          <div class="column padding-left-0 is-flex flex-align-centre">
            <img src="/static/img/home/hellopeter.svg" alt="hellopeter">&nbsp;&nbsp;
            <span class="section-title">Hellopeter Review Invite Template</span>
          </div>
          <div class="column is-flex flex-align-centre flex-justify-end padding-right-0">
            <img :src="`/static/img/ic-${accordion.reviewInvites.show ? 'down' : 'right'}-arrow.svg`" alt="hellopeter">
          </div>
        </div>
        <div class="columns is-block" v-if="accordion.reviewInvites.show">
          <!-- Email Section Begins -->
          <div class="column padding-left-0 padding-right-0 email-section">
            <p class="heading-text margin-bottom-12">Email Template</p>
            <div class="control tooltip-submission margin-bottom-12">
              <label class="dropdown-with-arrow">
                <div class="column is-paddingless is-flex flex-align-centre">
                  <label class="label is-size-7 color-58595b">Submission Type</label>
                  <tooltip-new class="column padding-top-0" content-width="335px">
                    <p>
                      <strong>In-mail invites</strong> allow your customers to write and submit reviews right from their email - without ever leaving their inbox.
                      <strong>Important</strong> - In-mail templates may not render on certain browsers, devices and email clients. In such cases we will automatically deliver a modified version of the in-mail template.<br>
                      <strong>Landing page invites</strong> drives customers out of their email to a landing page where they can write and submit their review.<br>
                      <strong>In-mail</strong> and <strong>Landing page invites</strong> do not require your customers to sign-in or register to write and submit reviews.
                    </p>
                  </tooltip-new>
                </div>
                <span class="is-5 is-one-fifth">
                  <select
                    data-track="Portal - Select In-Mail/Landing Page Submission Type"
                    class="input is-5 is-one-fifth"
                    v-model="accordion.reviewInvites.preview.mailType"
                    @change="getReviewInvitationTemplate('selected')"
                  >
                    <option value="LANDINGPAGE">Landing Page</option>
                    <option value="INMAIL">In-mail</option>
                  </select>
                  <i aria-hidden="true" class="fas fa-angle-down"></i>
                </span>
              </label>
            </div>
            <div class="column is-flex flex-align-center padding-left-0 padding-top-0" v-if="!isPaidSubscription">
              <div class="column is-narrow is-paddingless padding-bottom-0 is-flex flex-align-centre">
                <img src="/static/img/free-lock-icon.png" alt="lock">
              </div>
              <div class="column padding-bottom-0 is-block flex-align-center upgrade-section">
                <span><router-link :to="`/billing/edit-plan/g1/monthly`" class="upgrade-text">Upgrade</router-link> your plan to customise your email review invitation.</span>
                <br>
                <span>Create a custom message and add your brand’s imagery to increase conversations.</span>
              </div>
            </div>
            <div class="field has-margin-top-1 margin-bottom-12">
              <label class="label label-header" :class="[{'disabled': !userType}]">Email Subject</label>
              <div class="control">
                <input
                  :class="[{'cursor-not-allowed': !userType}, 'input']"
                  :disabled="!userType"
                  :readonly="!userType"
                  type="text"
                  placeholder="Text input"
                  v-model="accordion.reviewInvites.emailInvites.subject"
                  ref="emailInviteSubject"
                  @keyup="handleFieldChange"
                  @input="isTyping = true, accordion.reviewInvites.loader.isChanged = true"
                  @click="accordion.currentCursor = 'emailInviteSubject', accordion.element = 'subject'"
                >
              </div>
            </div>
            <div class="field margin-bottom-12">
              <label class="label label-header" :class="[{'disabled': !userType}]">Body</label>
              <div class="control">
              <textarea
                class="invite-body-textarea"
                :class="[{'cursor-not-allowed': !userType}, 'textarea has-fixed-size']"
                :disabled="!userType"
                :readonly="!userType"
                placeholder="Textarea"
                v-model="accordion.reviewInvites.emailInvites.body"
                ref="emailInviteBody"
                @keyup="handleFieldChange()"
                @input="accordion.reviewInvites.emailInvites.isTyping = true, accordion.reviewInvites.loader.isChanged = true"
                @click="accordion.currentCursor = 'emailInviteBody', accordion.element = 'body'"
              ></textarea>
              </div>
            </div>
            <div class="field">
              <label class="label label-header" :class="[{'disabled': !userType}]">Tags</label>
              <div class="control">
                <ul class="tags" :class="[{'disabled': !userType}]">
                  <li v-for="tag of accordion.reviewInvites.emailInvites.tags" v-bind:key="tag" class="tag" :class="[{'add-tag': userType}]" @click="handleTag(tag, 'accordion.reviewInvites.emailInvites')">{{tag}}</li>
                </ul>
              </div>
            </div>
            <!-- Allow user to add photos -->
            <div class="field" v-if="accordion.reviewInvites.preview.mailType === 'LANDINGPAGE'">
              <label class="label label-header" :class="[{'disabled': !userType}]">Upload Photos <br>
                <span class="allow-photo">Allow users to upload photos when they leave a review.</span>
              </label>
              <div class="control">
                <ul class="tags allow-photo-ul">
                  <label class="radio allow-photo-radio">
                    <input :disabled="!userType" type="radio" value="yes" @change="changeUploadOption" v-model="accordion.reviewInvites.emailInvites.allowToAddPhotos">&nbsp; Yes
                  </label>
                  <label class="radio allow-photo-radio">
                    <input :disabled="!userType" type="radio" value="no" @change="changeUploadOption" v-model="accordion.reviewInvites.emailInvites.allowToAddPhotos">&nbsp; No
                  </label>
                </ul>
              </div>
            </div> <!-- Allow user to add photos -->
          </div> <!-- Email Section Ends -->
          <!-- SMS Section Begins -->
          <div class="column padding-left-0 padding-right-0 sms-section">
            <p class="heading-text margin-bottom-12">SMS Template</p>
            <div class="field">
              <label class="label is-size-7 color-58595b">
                <div class="column is-paddingless is-flex flex-align-center">
                  <div class="column is-narrow padding-left-0">
                    Message
                  </div>
                  <div class="column is-narrow is-paddingless padding-bottom-0 is-flex flex-align-centre" v-if="!isPaidSubscription">
                    <img src="/static/img/free-lock-icon.png" alt="lock">
                  </div>
                  <div class="column padding-bottom-0 is-flex flex-align-center upgrade-section" v-if="!isPaidSubscription">
                    <router-link :to="`/billing/edit-plan/g1/monthly`" class="upgrade-text">Upgrade</router-link> &nbsp; your plan to create a custom SMS review invite message.
                  </div>
                </div>
              </label>
              <div class="control">
                <textarea
                  placeholder="Textarea"
                  :class="[{'disable-field': !org.billing}, 'textarea']"
                  ref="smsBody"
                  :readonly="!userType"
                  :disabled="!userType"
                  v-model="accordion.reviewInvites.smsInvites.body"
                  :maxlength="accordion.reviewInvites.smsInvites.max"
                  @keyup="handleFieldChange"
                  @input="accordion.reviewInvites.loader.isChanged = true"
                  @click="accordion.currentCursor = 'smsBody', accordion.element = 'body'"
                ></textarea>
                <p class="limit-160-characters">
                  Limit: 160 characters. Remaining <span class="input-group-addon" v-text="(accordion.reviewInvites.smsInvites.max - accordion.reviewInvites.smsInvites.body.length)"></span>
                </p>
              </div>
            </div>
            <div class="field">
              <label class="label is-size-7 color-58595b" :class="[{'disabled': !userType}]">Tags</label>
              <div class="control">
                <ul class="tags" :class="[{'disabled': !userType}]">
                  <li
                    v-for="tag of accordion.reviewInvites.smsInvites.tags"
                    v-bind:key="tag" class="tag" :class="[{'add-tag': userType}]"
                    @click="handleTag(tag, 'accordion.reviewInvites.smsInvites', accordion.reviewInvites.smsInvites.max)">
                    {{tag}}
                  </li>
                </ul>
              </div>
            </div>
            <br>
            <div class="column is-paddingless setting-text">
              For more Hellopeter settings and customisation options, go to <router-link to="/collect-reviews/look-and-feel">Email Settings</router-link>
            </div>
            <div class="columns flex-align-centre">
              <div class="column is-narrow padding-left-0" v-if="userType">
                <button
                  data-track="Portal - Save Email Invites Changes"
                  class="button is-button-dark-blue is-uppercase email-actions"
                  :class="[{'is-loading': accordion.reviewInvites.loader.isSaving}]"
                  :disabled="!accordion.reviewInvites.loader.isChanged"
                  @click="handleInvitesSaveChanges"
                >
                  Save Changes
                </button>
              </div>
              <div class="column is-flex flex-align-centre padding-right-0" v-if="userType">
                <input type="text" class="input" placeholder="Enter your email address" v-model="accordion.reviewInvites.emailInvites.test.email">
                <button
                  data-track="Portal - Send Email Invites Test Email"
                  class="button is-button-dark-blue-outline is-uppercase email-actions"
                  :class="[{'is-loading': accordion.reviewInvites.emailInvites.test.isSendingTest}]"
                  :disabled="!isValidEmail(accordion.reviewInvites.emailInvites.test.email)"
                  @click="handleInvitesSendTest(accordion.reviewInvites.emailInvites.test.email)"
                >
                  Send Test
                </button>
              </div>
            </div>
          </div> <!-- SMS Section Ends -->
        </div>
      </div> <!-- Review Invites Section Ends -->
      <!-- Google Invites Section Begins -->
      <div class="google-invite-section" :class="[{'padding-bottom': accordion.googleInvites.show}]">
        <div class="column is-flex flex-align-centre is-full is-paddingless" @click="preparePreview('googleInvites')">
          <div class="column padding-left-0 is-flex flex-align-centre">
            <img src="/static/img/home/google-mini.png" alt="google">&nbsp;&nbsp;
            <span class="section-title">Google Review Invite Template</span>
          </div>
          <div class="column is-flex flex-align-centre flex-justify-end padding-right-0">
            <img :src="`/static/img/ic-${accordion.googleInvites.show ? 'down' : 'right'}-arrow.svg`" alt="google">
          </div>
        </div>
        <div class="columns is-block" v-if="accordion.googleInvites.show && !(isGMBLoading === true || isGMBSettedUp === false)">
          <div class="column padding-left-0 padding-top-0 distribution-section">
            <div class="column padding-left-0 is-paddingless">
              <span class="column is-narrow is-paddingless is-flex flex-align-centre">
                <p class="column is-narrow padding-left-0 padding-right-0 heading-text">Review Distribution</p>
                <tooltip-new class="column padding-top-0" content-width="282px">
                  This email template will be delivered to all customers you’d like to write a Google review. Note -
                  Your customers can only write a Google review if they have a Gmail or G-Suite account. Our system
                  automatically filters review invites to send Google invites only to users with a Gmail or G-Suite address.
                </tooltip-new>
              </span>
            </div>
            <div class="column is-paddingless is-flex flex-align-centre">
              <p class="distribution-text"><span class="percentage">{{gmbDistributionValue}}</span> % of my review invites will be distributed to G suite accounts.</p> &nbsp;&nbsp;
              <router-link to="/collect-reviews/google-reviews" class="has-text-underlined color-2aabe1 is-12">Edit</router-link>
            </div>
          </div>
          <div class="column padding-left-0 padding-right-0 email-section margin-top-10" :class="[{'disabled-section': gmbDistributionValue < 1 ? true : false}]">
            <p class="heading-text margin-bottom-12">Email Template</p>
            <div class="field has-margin-top-1 margin-bottom-12">
              <label class="label label-header">Email Subject</label>
              <div class="control">
                <input
                  :class="[{'disable-field': !userType}, 'input']"
                  type="text"
                  placeholder="Text input"
                  v-model="accordion.googleInvites.gmb.subject"
                  ref="gmbSubject"
                  @keyup="handleFieldChange"
                  @input="accordion.googleInvites.gmb.loader.isChanged = true"
                  @click="accordion.currentCursor = 'gmbSubject', accordion.element = 'subject  '"
                >
              </div>
            </div>
            <div class="field margin-bottom-12">
              <label class="label label-header">Body</label>
              <div class="control">
              <textarea
                class="invite-body-textarea"
                :class="[{'disable-field': !userType},'textarea has-fixed-size']"
                placeholder="Textarea"
                v-model="accordion.googleInvites.gmb.body"
                ref="gmbBody"
                @keyup="handleFieldChange()"
                @input="accordion.googleInvites.gmb.loader.isChanged = true"
                @click="accordion.currentCursor = 'gmbBody', accordion.element = 'body'"
              ></textarea>
              </div>
            </div>
            <div class="field">
              <label class="label label-header">Tags</label>
              <div class="control">
                <ul class="tags">
                  <li v-for="tag of accordion.googleInvites.gmb.tags" v-bind:key="tag" class="tag" :class="[{'add-tag': userType}]" @click="handleTag(tag, 'accordion.googleInvites.gmb')">{{tag}}</li>
                </ul>
              </div>
            </div>
          </div> <!-- Email Section Ends -->
          <div class="column is-paddingless setting-text">
            For more Google settings and customisation options, go to <router-link to="/collect-reviews/google-reviews">Google Settings</router-link>
          </div>
          <div class="column is-paddingless">
            <div class="columns">
              <div class="column is-narrow padding-left-0">
                <button
                  data-track="Portal - Save GMB Content Changes"
                  class="button is-button-dark-blue is-uppercase email-actions"
                  :class="[{'is-loading': accordion.googleInvites.gmb.loader.isSaving}]"
                  :disabled="!accordion.googleInvites.gmb.loader.isChanged"
                  @click="handleInvitesSaveGMBContent"
                >
                  Save Changes
                </button>
              </div>
              <div class="column is-flex flex-align-centre padding-right-0" :class="[{'disabled-section': gmbDistributionValue < 1 ? true : false}]">
                <input type="text" class="input" placeholder="Enter your email address" v-model="accordion.googleInvites.gmb.test.email">
                <button
                  data-track="Portal - Send GMB Invites Test Email"
                  class="button is-button-dark-blue-outline is-uppercase email-actions"
                  :class="[{'is-loading': accordion.googleInvites.gmb.test.isSendingTest}]"
                  :disabled="!isValidEmail(accordion.googleInvites.gmb.test.email)"
                  @click="handleInvitesSendTest(accordion.googleInvites.gmb.test.email, 'GMB')"
                >
                  Send Test
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-block" v-if="accordion.googleInvites.show && (isGMBLoading === true || isGMBSettedUp === false)">
          <GMBSetup
            :class="{'hide-gmb-setup-box': isGMBLoading}"
            v-if="isGMBLoading === true || isGMBSettedUp === false"
            :isPaidSubscription="userType"
            :showGMBTokenError="accordion.googleInvites.gmb.showGMBTokenError"
            :showGMBAccessError="accordion.googleInvites.gmb.showGMBAccessError"
            @updateFinished="gmbUpdateFinished"
          ></GMBSetup>
        </div>
      </div> <!-- Google Invites Section Ends -->
      <!-- Customer Section Begins -->
      <div class="column is-paddingless customer-section">
        <p class="heading-text">Add Your Customers</p>
        <span class="description">
          Upload customer details individually or bulk upload a CSV file.
          The CSV file must contain First Name and Customer Email and can include up to 1,000 rows.
          If you add a Mobile Number, an SMS invite will be sent in addition to the email invite.
          Mobile numbers are not mandatory and SMS invites will not be deducted from your review invite quota.
        </span><br>
        <div class="column is-inline-flex padding-left-0 flex-align-centre flex-wrap">
          <div class="column padding-left-0 is-narrow pos-relative">
            <button class="is-button action-button is-uppercase is-loading" @click="openIndividualModal">Individual Upload</button>
            <!-- Add Individual Customer Section Begins -->
            <div class="columns is-block add-individual-customer-section" v-if="page.addCustomers.individualUpload">
              <div class="column is-paddingless is-flex flex-align-centre">
                <span class="column padding-bottom-0 label-text">Add Individual Customer</span>
                <img class="column padding-bottom-0 is-narrow flex-justify-end pointer" src="/static/img/ads/modal_close.svg" alt="Cancel" @click="page.addCustomers.individualUpload = false">
              </div>
              <div class="column is-paddingless">
                <div class="column padding-top-0">
                  <label class="label-text">First Name</label><br>
                  <input type="text" placeholder="First name" class="width-full" v-model="page.addCustomers.firstName">
                </div>
                <div class="column">
                  <label class="label-text">Email Address</label><br>
                  <input type="text" placeholder="Email address" class="width-full" v-model="page.addCustomers.email">
                  <span class="error">{{page.addCustomers.error}}</span>
                </div>
                <div class="column">
                  <label class="label-text">Mobile Number</label> <span class="optional-text">(optional)</span><br>
                  <input type="text" placeholder="000 000 0000" class="width-full" v-model="page.addCustomers.number">
                </div>
                <div class="column has-text-centered">
                  <button
                    class="button is-button-dark-blue is-uppercase"
                    data-track="Portal - Add Individual Invite"
                    :class="[{'is-loading': page.addCustomers.loaders.isAdding}]"
                    :disabled="!singleInviteDetailAdded"
                    @click="handleAddSingleCustomer"
                  >
                    Add Customer
                  </button>
                </div>
              </div>
            </div> <!-- Add Individual Customer Section Ends -->
          </div>
          <div class="column padding-left-0 is-narrow">
            <button
              class="button action-button is-uppercase"
              data-track="Portal - Bulk Upload of CSV Invites"
              :class="[{'is-loading': page.addCustomers.loaders.isBulkUploading}]"
              @click="$refs.uploadedCSV.click()"
            >
              Bulk Upload
            </button>
            <input type="file" ref="uploadedCSV" class="is-hidden" accept=".csv" @change="handleBulkUpload">
          </div>
          <div class="column padding-left-0 padding-right-0 is-narrow font-size-12 color-707070">Upload a CSV file,
            <a data-track="Portal - Download Invites Template" :href="getTemplateUrl" class="has-text-underlined color-2aabe1 margin-top-20 margin-bottom-20" download>download our template</a> for guidance
          </div>
        </div>
        <div class="column is-paddingless data-section">
          <div class="column is-narrow padding-top-0 padding-left-0">{{page.addCustomers.stats.uploaded.count}} Records uploaded <span v-if="page.addCustomers.stats.uploaded.count">- <span class="has-text-underlined color-2aabe1 cursor-pointer" @click="handleRemoveAllRecords">remove all records</span></span></div>
          <div class="column is-narrow is-success padding-left-0 padding-top-0" v-if="page.addCustomers.stats.added.count"><i class="fa fa-check"></i> &nbsp;
            {{page.addCustomers.stats.added.count}} customers added to queue
          </div>
          <div class="column is-flex padding-left-0 padding-top-0">
            <div class="column is-narrow is-danger is-paddingless" v-if="page.addCustomers.stats.notAdded.count"><i class="fa fa-times"></i> &nbsp;
              {{page.addCustomers.stats.notAdded.count}} not added
            </div>
            <div class="column is-narrow is-paddingless pointer" :class="[{'is-hidden': !page.addCustomers.stats.notAdded.count}]">
              &nbsp;- <a data-track="Portal - Download Errors File from Upload" href="" ref="errorFileDownLink" target="_blank" download class="has-text-underlined color-2aabe1">download file</a>
            </div>
          </div>
        </div>
        <!-- Upgrade Section Begins -->
        <div class="column padding-left-0 upgrade-section" v-if="!(this.statistics.invites && this.statistics.invites.remaining > 0 ? true : false) && (isMonthlyOrFreeSubscription || isYearlySubscription) && upgrade.status">
          <div class="column padding-bottom-0 margin-bottom-10">
            <span class="text">You have no Review Invites remaining</span>
          </div>
          <!-- Free/Monthly Plan Section Begins -->
          <div class="column" v-if="isMonthlyOrFreeSubscription && !(this.statistics.invites && this.statistics.invites.remaining > 0 ? true : false)">
            <span class="message is-flex flex-align-center">
              <span><img src="/static/img/free-lock-icon.png" alt="upgrade"></span>&nbsp;&nbsp;
              <span><router-link :to="subscUpgradeUrl" class="has-text-underlined color-2aabe1">Upgrade</router-link></span>&nbsp;
              to send Review Invites now or wait for your monthly plan to renew.
            </span>
          </div> <!-- Free/Monthly Plan Section Ends -->
          <!-- Annual Plan Section Begins -->
          <div class="column padding-top-0" v-if="isYearlySubscription && !(this.statistics.invites && this.statistics.invites.remaining > 0 ? true : false)">
            <span class="message is-flex flex-align-center" v-if="0">
              <span><img src="/static/img/free-lock-icon.png" alt="upgrade"></span>&nbsp;&nbsp;
              <span><router-link :to="subscUpgradeUrl" class="has-text-underlined color-2aabe1">Upgrade</router-link></span>&nbsp;
              or purchase Review Invites to send now.
            </span>
            <div class="column is-paddingless is-flex is-narrow invite-package-count-row">
              <BuyDigits
                :config="{name: 'Review Invites', type: 'Invites', header: false, upgradeText: 'or purchase Review Invites to send now.'}"
              />
            </div>
          </div> <!-- Annual Plan Section Ends -->
        </div> <!-- Upgrade Section Ends -->
        <div class="column padding-left-0 padding-top-0 has-text-left mt-5">
          <button
            data-track="Portal - Send Email Invites To Added Users"
            class="button is-uppercase email-actions"
            :class="[{'is-loading': page.addCustomers.loaders.isBulkSending}, {'is-button-dark-blue': isEligibleToInvite}, {'send-invites-button': !isEligibleToInvite}]"
            :disabled="!isEligibleToInvite"
            disabled1="!accordion.reviewInvites.loader.isChanged || !accordion.googleInvites.loader.isChanged"
            @click="showTermsModal"
          >
            Send Invites
          </button> <!--grey-button-->
        </div>
      </div> <!-- Customer Section Ends -->
    </div> <!-- Text Section Ends -->
    <!-- Template Preview Section Begins -->
    <div class="column">
      <div class="right-section column preview has-spinner">
        <h6 class="is-size-7  title-business preview-header">Preview
          <div class="preview-mobile-desktop-icon">
            <div class="preview-toggle-icons">
              <span class="desktop-icon"
                    v-on="accordion[accordion.active].preview.isActive ? { click: () => responsive('desktop') } : {click: ($event) => $event.preventDefault() }"
                    :class="{ 'has-text-weight-bold active': !accordion[accordion.active].preview.isActive }">
                <img class="ds1" src="/static/img/desktop-icon-white.png">
                <img class="ds2" src="/static/img/desktop-icon-grey1.png">
              </span>
              <span class="mob-icon"
                    v-on="!accordion[accordion.active].preview.isActive ? { click: () => responsive('mobile') } : {click: ($event) => $event.preventDefault() }"
                    :class="{ 'has-text-weight-bold active': accordion[accordion.active].preview.isActive }">
                <img class="mb1" src="/static/img/mobile-icon-white.png">
                <img class="mb2"  src="/static/img/mobile-icon-grey.png">
              </span>
            </div>
          </div>
        </h6>
        <div v-if="accordion[accordion.active].preview.isPreviewing">
          <p class="has-text-centered">
            <img class="has-spinner__spinner" src="/static/img/spinner.svg" alt="fetching Review Breakdown..." />
          </p>
        </div>
        <iframe :srcdoc="accordion[accordion.active].preview.htmlPreview" :width="accordion[accordion.active].preview.iframeWidth" height="580" style="margin-top: 20px; transform: scale(0.9); " v-if="!accordion[accordion.active].preview.isPreviewing"></iframe>
      </div>
    </div> <!-- Template Preview Section Ends -->
    <!-- Confirmation Modal -->
    <ModalPopup
      class="modal"
      title="Before you continue"
    >
      <template class="body" slot="body">
        By checking the “I Accept” box below, you confirm your obligations under Hellopeter’s <a class="text-underline" href="https://www.hellopeter.com/legal/legal" target="_blank">Terms of service</a> that email
        addresses uploaded are authentic and verified to explicitly match the email addresses provided by your customers.
        By accepting these conditions, you confirm that Hellopeter’s Manual Review Invites will not be used for any deceptive
        purpose including, but not limited to, generating false reviews or artificially altering your average review score.
        <br><br>
        Failure to comply with these terms is a material breach of Hellopeter’s Terms of Service and may result in the
        termination of your Hellopeter account. In addition, Hellopeter reserves the right to publicise your conduct on
        the Site in such manner as we deem appropriate which may take the form of a penalty notice on your public facing
        profile explaining that your business reviews are suspicious.

        <div class="columns is-flex accept-section">
          <div class="column is-narrow padding-left-0 padding-bottom-0 checkbox">
            <input data-track="Portal - Agreed with T&C in Bulk Invite" type="checkbox" v-model="page.addCustomers.termAccepted">
          </div>
          <div class="column is-narrow padding-left-0 padding-bottom-0">
            I Accept
          </div>
        </div>
      </template>
      <template slot="footer">
        <footer class="modal-card-foot is-hidden-mobile">
          <div class="columns is-flex flex-align-centre">
            <div class="column padding-left-0 padding-top-0 has-text-left">
              <button class="button is-button-dark-blue-outline is-uppercase" @click="$refs.uploadedCSV.value = null, page.addCustomers.termAccepted = false, showModal(false)">Cancel</button>
            </div>
            <div class="column padding-right-0 padding-top-0 has-text-right">
              <button
                data-track="Portal - Send Bulk Email Invites"
                class="button is-button-dark-blue is-uppercase"
                :class="[{'is-loading': page.addCustomers.loaders.isSending}]"
                :disabled="!page.addCustomers.termAccepted"
                @click="handleSendBulkInvites"
              >
                Send Invites
              </button>
            </div>
          </div>
        </footer>
      </template>
    </ModalPopup>
    <!-- Confirmation Modal -->
  </div>
</template>

<script>
/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape, valid-jsdoc, no-unused-vars */
import axios from 'axios'
import {gmb, misc} from '@/mixins'
import {TooltipNew} from '@/widgets'
import { mapState, mapActions } from 'vuex'
import {GMBModal, ModalPopup, BuyDigits} from '@/components'
import { SHOW_MODAL, STORE_INVITE_STATS } from '@/store/action.types'
import GMBSetup from '@/pages/collect-reviews/gmb/GMBSetup.vue'

export default {
  name: 'EmailAndSMS',
  metaInfo: {
    title: 'Business Portal | Hellopeter - Email and SMS Settings'
  },
  mixins: [gmb, misc],
  components: {
    GMBSetup,
    GMBModal,
    BuyDigits,
    ModalPopup,
    TooltipNew
  },
  data () {
    return {
      org: {
        id: localStorage.getItem('org_id'),
        slug: localStorage.getItem('org_slug'),
        billing: JSON.parse(localStorage.billingDetails)
      },
      upgrade: {status: false},
      page: {
        addCustomers: {
          email: '',
          error: '',
          number: '',
          firstName: '',
          termAccepted: false,
          individualUpload: false,
          loaders: {isSending: false, isAdding: false, isBulkUploading: false, isBulkSending: false},
          stats: {
            added: {show: true, count: 0},
            uploaded: {show: true, count: 0},
            notAdded: {show: true, count: 0}
          }
        }
      },
      accordion: {
        active: 'reviewInvites',
        element: '',
        currentCursor: '',
        reviewInvites: {
          show: false,
          loader: {isSaving: false, isTyping: false, isChanged: false},
          preview: {
            isActive: false,
            htmlPreview: '',
            iframeWidth: '600px',
            isPreviewing: false,
            mailType: localStorage.getItem('mailType') ? localStorage.getItem('mailType').replace(/['"]+/g, '') : 'INMAIL' /** ['INMAIL', 'LANDINGPAGE'] */
          },
          emailInvites: {
            tags: [],
            body: '',
            image: {},
            subject: '',
            allowToAddPhotos: 'no',
            test: {
              email: '',
              isSendingTest: false
            }
          },
          smsInvites: {
            max: 160,
            tags: [],
            body: '',
            subject: ''
          }
        },
        googleInvites: {
          show: false,
          preview: {
            isActive: false,
            htmlPreview: '',
            iframeWidth: '600px',
            isPreviewing: false
          },
          gmb: {
            body: '',
            subject: '',
            mailType: 'GMB',
            showGMBAccessError: false,
            showGMBTokenError: false,
            loader: {isSaving: false, isChanged: false},
            test: {
              email: '',
              isSendingTest: false
            }
          }
        }
      },
      businessSlug: localStorage.getItem('org_slug')
    }
  },
  computed: {
    ...mapState({
      modalPopup: state => state.app.modal,
      statistics: state => state.app.statistics
    }),
    /**
     * Get template URL to download sample
     * @return {string}
     */
    getTemplateUrl () {
      if (this.org.billing.subscription.name === 'Free') {
        return `/static/assets/invite_template_free.csv`
      }
      return `/static/assets/invite_template_pro.csv`
    },
    /**
     * Check the user type whether it is of Enterprise/Pro
     * @return {boolean}
     */
    userType () {
      // If user having Enterprise/Pro business
      return this.org.billing.subscription.name !== 'Free'
    },
    /**
     * Check the user type whether it is of Enterprise/Pro
     * @return {boolean}
     */
    isPaidSubscription () {
      // If user having Enterprise/Pro business
      return this.org.billing.subscription.name !== 'Free'
    },
    /**
     * Check if user has a free or any monthly subscription
     * @return {boolean}
     */
    isMonthlyOrFreeSubscription () {
      return (['Free', 'G1', 'G2', 'G3', 'G4']).includes(this.org.billing.subscription.name) && ([1, 6, 7, 8, 9]).includes(this.org.billing.subscription.subscriptionTypeId)
    },
    /**
     * Check if user has an annual subscription
     * @return {boolean}
     */
    isYearlySubscription () {
      return (['G1', 'G2', 'G3', 'G4', 'P1', 'P2', 'P3']).includes(this.org.billing.subscription.name) && ([10, 11, 12, 13, 14, 15, 16]).includes(this.org.billing.subscription.subscriptionTypeId)
    },
    /**
     * Check if GMB is set or not
     * @return {void}
     */
    isGMBSettedUp () {
      if (this.gmbSetup.token === undefined) {
        return false
      }
      if (this.gmbSetup.data !== undefined && this.gmbSetup.data !== null) {
        return true
      }
      return false
    },
    /**
     * Check if Single Invite Data Added Correctly
     * @return {void}
     */
    singleInviteDetailAdded () {
      return this.page.addCustomers.firstName && this.isValidEmail(this.page.addCustomers.email)
    },
    /**
     * Check if user is eligible to invite
     * @return {boolean}
     */
    isEligibleToInvite () {
      return (this.page.addCustomers.stats.uploaded.count && (this.statistics.invites && this.statistics.invites.remaining > 0))
    }
  },
  created () {
    this.getReviewInvitesData()
    this.getSMSDetails()
    this.checkGMBSetup()
    this.getAddedInviteData()
    this.getReviewInvitationTemplate('selected')
    // Event bus for modal's response
    window.events.$on('navigateTowardsRoute', this.handleNavigation)
    window.events.$emit('loadHeaderStats')
    // Adding the unload event, when user want to leave unsaved changes
    window.addEventListener('beforeunload', (event) => {
      // If user changed the form and is Paid user
      if ((this.accordion.reviewInvites.loader.isChanged || this.accordion.googleInvites.gmb.loader.isChanged) && this.userType) {
        event.preventDefault()
        event.returnValue = 'You have unsaved changes. If you close this tab, your changes will be lost.'
      }
    })
  },
  methods: {
    ...mapActions({
      showModal: `app/${SHOW_MODAL}`,
      saveInvitationStats: `app/${STORE_INVITE_STATS}`
    }),
    /**
     * Get updated review invite count
     * @return {void}
     */
    getReviewInvitesData () {
      axios.get(`/${this.org.id}/review-invites?page=0`)
      .then(response => {
        if (!response.data.invitationStats.pending) {
          this.upgrade.status = true
        }
        if (typeof response.data.invitationStats.pending !== 'undefined') {
          this.saveInvitationStats(Object.assign(this.statistics, {
            invites: {
              remaining: response.data.invitationStats.pending
            }
          }))
        }
      })
    },
    /**
     * Set which Template to show for preview
     * @return {void}
     */
    preparePreview (previewType = 'reviewInvites') {
      let madeIncative = previewType !== 'reviewInvites' ? 'reviewInvites' : 'googleInvites'
      if (this.accordion[madeIncative].show) {
        this.accordion[madeIncative].show = false
      }
      this.accordion.active = previewType
      this.accordion[previewType].show = !this.accordion[previewType].show
      previewType === 'reviewInvites' ? this.getReviewInvitationTemplate('selected') : this.getGMBTemplate()
    },
    /**
     * Toggle between Desktop and mobile preview
     * @return {void}
     */
    responsive (type) {
      this.accordion[this.accordion.active].preview.isActive = !this.accordion[this.accordion.active].preview.isActive
      this.accordion[this.accordion.active].preview.iframeWidth = type === 'desktop' ? '600px' : '320px'
    },
    /**
     * When user change any text in fields
     * @return {void}
     */
    handleFieldChange () {
      this.isFormChanged = true
    },
    /**
     * Change option to add photos
     */
    changeUploadOption (e) {
      this.accordion.reviewInvites.loader.isChanged = true
      this.accordion.reviewInvites.emailInvites.allowToAddPhotos = e.target.value
      this.handleFieldChange()
    },
    /**
     * Replace the selected tag with selected string or at end of textarea string
     * @param {string} tag Selected tag
     * @param {number} maxlength Maxlength for selected field
     * @return {void}
     */
    handleTag (tag, dataId = '', maxlength = false) {
      // If user is Enterprise/Pro business user
      if (this.userType) {
        let keysArray = dataId.split('.')
        let storedVal = {accordion: ''}
        keysArray.forEach((val, index) => {
          if (index === 0) {
            storedVal = this[val]
          } else {
            storedVal = storedVal[val]
          }
        })
        this.handleFieldChange()
        // Getting the reference where to append tag [subject|body]
        let tArea = this.$refs[this.accordion.currentCursor]
        let startPos = tArea.selectionStart
        let endPos = tArea.selectionEnd
        let tmpStr = tArea.value
        // insert the chosen tag to selected text or at very end of the textarea string
        let newStr = tmpStr.substring(0, startPos) + ` ${tag} ` + tmpStr.substring(endPos, tmpStr.length)
        if (!maxlength || (newStr.length <= maxlength)) {
          storedVal[this.accordion.element] = newStr
        }
      }
    },
    /**
     * Checking entered email is valid and has no validation error
     * @param {string} testEmail
     * @return {boolean}
     */
    isValidEmail (testEmail) {
      let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return regex.test(testEmail)
    },
    /**
     * Get all the details of uploaded data
     * @return {void}
     */
    getAddedInviteData () {
      axios.get(`/${this.org.id}/review-invites?page=1`)
      .then(({data}) => {
        this.page.addCustomers.stats.uploaded.count = data.total
        // this.page.addCustomers.stats.added.count = this.page.addCustomers.stats.notAdded.count = 0
      })
      .catch(() => {
        flash('Failed to load review invitation queue records', `is-danger`)
      })
    },
    /**
     * Get the invitation template content for preview
     * @return {void}
     */
    getReviewInvitationTemplate (mode = 'get') {
      let data = {
        type: this.accordion.reviewInvites.preview.mailType
      }
      if (mode === 'get') {
        data = Object.assign(data, {body: '', subject: '', mode: 'get'})
      } else if (mode === 'selected') {
        data = Object.assign(data, {body: '', subject: '', mode: 'selected'})
      } else {
        data = Object.assign(data, {body: this.accordion.reviewInvites.emailInvites.body, subject: this.accordion.reviewInvites.emailInvites.subject, files: this.accordion.reviewInvites.emailInvites.image, allowToAddPhotos: this.accordion.reviewInvites.emailInvites.allowToAddPhotos, mode: 'preview'})
      }
      axios.post(`/${this.org.slug}/review/get-invite-template`, data)
      .then((response) => {
        localStorage.setItem('mailType', JSON.stringify(this.accordion.reviewInvites.preview.mailType))
        Object.assign(this.accordion.reviewInvites.emailInvites, response.data, {
          image: response.data.attachment,
          allowToAddPhotos: response.data.allowUserToUpload ? response.data.allowUserToUpload : 'no'
        })
        this.accordion.reviewInvites.preview = {
          iframeWidth: '600px',
          htmlPreview: response.data.view,
          isPreviewing: false
        }
        if (response.data.type !== undefined) {
          this.accordion.reviewInvites.preview.mailType = response.data.type
        }
      })
      .catch(() => {
        flash('You are not authorized to view this resource.', 'is-danger')
      })
    },
    /**
     * Get the SMS Invitation Details
     * @return {void}
     */
    getSMSDetails (mode = 'get') {
      let data = {
        type: 'SMS'
      }
      if (mode === 'get') {
        data = Object.assign(data, {body: '', subject: '', mode: 'get'})
      } else if (mode === 'selected') {
        data = Object.assign(data, {body: '', subject: '', mode: 'selected'})
      } else {
        data = Object.assign(data, {body: this.body, subject: this.subject, mode: 'preview'})
      }
      axios.post(`/${this.org.slug}/review/get-review-invite-sms-template`, data)
      .then((response) => {
        Object.assign(this.accordion.reviewInvites.smsInvites, response.data)
      })
      .catch(() => {
        flash('You are not authorized to view this resource.', 'is-danger')
      })
    },
    /**
     * Get the GMB Template for preview
     * @return {void}
     */
    getGMBTemplate (mode = 'get') {
      let data = {
        type: 'GMB'
      }
      if (mode === 'get') {
        data = Object.assign(data, {body: '', subject: '', mode: 'get'})
      } else if (mode === 'selected') {
        data = Object.assign(data, {body: '', subject: '', mode: 'selected'})
      } else {
        data = Object.assign(data, {
          body: this.accordion.googleInvites.gmb.body,
          subject: this.accordion.googleInvites.gmb.subject,
          files: this.accordion.googleInvites.gmb.image,
          allowToAddPhotos: this.accordion.googleInvites.gmb.allowToAddPhotos,
          mode: mode
        })
      }
      axios.post(`/${this.businessSlug}/review/get-invite-template`, data)
      .then((response) => {
        Object.assign(this.accordion.googleInvites.gmb, response.data, {
          image: response.data.attachment,
          allowToAddPhotos: response.data.allowUserToUpload
        })
        this.accordion.googleInvites.preview = {
          iframeWidth: '600px',
          htmlPreview: response.data.view,
          isPreviewing: false
        }
      })
      .catch(() => {
        flash('You are not authorized to view this resource.', 'is-danger')
      })
    },
    gmbUpdateFinished () {
      this.checkGMBSetup()
      window.location.reload()
    },
    /**
     * Open individual modal to add Customers
     * @return {void}
     */
    openIndividualModal () {
      this.page.addCustomers.individualUpload = !this.page.addCustomers.individualUpload
    },
    /**
     * Handle addition of individual Customer
     * @return {void}
     */
    handleAddSingleCustomer () {
      this.page.addCustomers.error = ''
      this.page.addCustomers.loaders.isAdding = true
      axios.post(`/${this.org.id}/review-invites`, {
        firstName: this.page.addCustomers.firstName,
        email: this.page.addCustomers.email,
        number: this.page.addCustomers.number
      })
      .then(() => {
        this.displaySuccessMsg(`Added to queue successfully.`, 'Portal - Successfully Added Manual Review Invitation To Queue')
        this.getAddedInviteData()
        this.openIndividualModal()
        this.page.addCustomers.stats.added.count += 1
      })
      .catch((error) => {
        if (typeof error.response.data.error === 'string' || error.response.data.error instanceof String) {
          this.page.addCustomers.error = error.response.data.error
        } else {
          Object.keys(error.response.data.errors).map((key) => {
            flash(error.response.data.errors[key][0], 'is-danger')
          })
        }
      })
      .finally(() => {
        this.getAddedInviteData()
        this.page.addCustomers.loaders.isAdding = false
        this.page.addCustomers.firstName = this.page.addCustomers.email = this.page.addCustomers.number = ''
      })
    },
    /**
     * Handle Bulk File Upload
     * @return {void}
     */
    handleBulkUpload (e) {
      let file = e.target.files[0]
      this.csvError = ''
      this.uploading = true
      this.page.addCustomers.loaders.isBulkUploading = true
      let formData = new FormData()
      formData.append('file', file)
      axios.post(`/${this.org.id}/review-invites/upload-csv`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      .then(({data}) => {
        this.page.addCustomers.stats.added.count = data.recordsAdded
        this.page.addCustomers.stats.notAdded.count = data.recordsFailed
        this.displaySuccessMsg('CSV Uploaded successfully.', 'Portal - Admin | CSV Uplaoded successfully.')
        this.getAddedInviteData()
        if (data.recordsFailed) {
          let csv = ['FIRST_NAME, EMAIL_ADDRESS, MOBILE_NUMBER, ERROR']
          data.faultyRecords.forEach(row => {
            row = row.join(',')
            csv.push(row)
          })
          csv = csv.join('\n')

          const fileName = file.name.split('.')
          fileName.pop()
          this.$refs.errorFileDownLink.download = `${fileName}_error.csv`
          this.$refs.errorFileDownLink.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
        }
      })
      .catch(() => {
        flash('Failed to upload CSV for review invite queue', `is-danger`)
      })
      .finally(() => {
        this.$refs.uploadedCSV.value = null
        this.page.addCustomers.loaders.isBulkUploading = false
      })
    },
    /**
     * Send test email to given email
     * @param {string} email
     * @param {string} type
     * @return {void}
     */
    handleInvitesSendTest (email, type = '') {
      this.accordion.reviewInvites.emailInvites.test.isSendingTest = this.accordion.googleInvites.gmb.test.isSendingTest = true
      axios.post(`/${this.businessSlug}/review/send-test-email`, {
        type: type,
        email: email
      })
      .then(({data}) => {
        this.accordion.reviewInvites.emailInvites.test.isSendingTest = this.accordion.googleInvites.gmb.test.isSendingTest = false
        this.accordion.reviewInvites.emailInvites.test.email = this.accordion.googleInvites.gmb.test.email = ''
        this.displaySuccessMsg(data.message, 'Portal - Admin | Review Invitations test email sent successfully.')
      })
      .catch(({response}) => {
        this.accordion.reviewInvites.emailInvites.test.isSendingTest = false
        flash(response.data.message, 'is-danger')
      })
    },
    /**
     * Save the subject/body for Hellopeter Review Invite Setup
     * @return {void}
     */
    handleInvitesSaveChanges () {
      this.accordion.reviewInvites.loader.isSaving = true
      this.isSaving = true
      axios.post(`/${this.businessSlug}/review/invite-template`, {
        body: this.accordion.reviewInvites.smsInvites.body,
        subject: this.accordion.reviewInvites.smsInvites.subject,
        type: 'sms'
      })
      .catch((error) => {
        flash(error.response.data.message, 'is-danger')
      })
      axios.post(`/${this.businessSlug}/review/invite-template`, {
        body: this.accordion.reviewInvites.emailInvites.body,
        subject: this.accordion.reviewInvites.emailInvites.subject,
        type: this.accordion.reviewInvites.preview.mailType,
        allowToAddPhotos: this.accordion.reviewInvites.preview.mailType === 'LANDINGPAGE' ? this.accordion.reviewInvites.emailInvites.allowToAddPhotos : 'no',
        files: this.accordion.reviewInvites.emailInvites.image,
        setAsSelected: false
      })
      .then((response) => {
        localStorage.setItem('mailType', this.accordion.reviewInvites.preview.mailType)
        this.displaySuccessMsg(response.data.message, 'Portal - Review Invite Content Saved')
        this.accordion.reviewInvites.loader.isSaving = this.accordion.reviewInvites.loader.isChanged = false
        this.accordion.reviewInvites.emailInvites.allowToAddPhotos = 'no'
        this.getReviewInvitationTemplate('get')
      })
      .catch((error) => {
        this.accordion.reviewInvites.loader.isSaving = false
        flash(error.response.data.message, 'is-danger')
      })
    },
    /**
     * Save the subject/body for GMB Setup
     * @return {void}
     */
    handleInvitesSaveGMBContent () {
      this.accordion.googleInvites.gmb.loader.isSaving = true
      axios.post(`/${this.businessSlug}/review/invite-template`, {
        body: this.accordion.googleInvites.gmb.body,
        subject: this.accordion.googleInvites.gmb.subject,
        type: this.accordion.googleInvites.gmb.mailType,
        setAsSelected: false,
        allowToAddPhotos: 'no'
      })
      .then((response) => {
        flash(response.data.message, 'is-success')
        this.accordion.googleInvites.gmb.loader.isSaving = this.accordion.googleInvites.gmb.loader.isChanged = false
        this.getGMBTemplate('get')
      })
      .catch((error) => {
        this.accordion.googleInvites.gmb.loader.isSaving = false
        flash(error.response.data.message, 'is-danger')
      })
    },
    /**
     * Handling redirection when user want to leave the page
     * @param routeTowards Route towards request is navigating
     * @return {void}
     */
    handleNavigation (routeTowards) {
      if ((this.accordion.reviewInvites.loader.isChanged || this.accordion.googleInvites.gmb.loader.isChanged) && this.userType) {
        this.accordion.reviewInvites.loader.isChanged = this.accordion.googleInvites.gmb.loader.isChanged = false
        this.$router.push({ path: routeTowards })
      }
    },
    /**
     * Handle Terms modal before Send Bulk Invites
     * @return {void}
     */
    showTermsModal () {
      this.page.addCustomers.termAccepted = false
      this.showModal()
    },
    /**
     * Handle send bulk invites
     * @return {void}
     */
    handleSendBulkInvites () {
      this.page.addCustomers.loaders.isBulkSending = true
      axios.post(`/${this.org.id}/review-invites/send-invites`, {
        bizSlug: this.org.slug
      })
      .then(({data}) => {
        let invitesSentCount = 0
        invitesSentCount = data.sent
        if (data.sent === data.toSend) {
          this.displaySuccessMsg(`All review invitations successfully sent.`, 'Successfully sent all review invitations')
        } else {
          invitesSentCount = data.toSend - data.sent
          this.displaySuccessMsg(`${data.sent} review invitations successfully sent. ${data.toSend - data.sent} not sent because the total number of review invites available on your package has been reached.`, 'Successfully sent review invitations with some unsent invitations')
        }
      })
      .catch(error => {
        flash('', 'is-danger')
        this.displayErrMsg(error, 'Failed sending Review Invitations on Collect Reviews View', `Failed to send review invitations`)
      })
      .finally(() => {
        window.events.$emit('loadHeaderStats')
        this.page.addCustomers.loaders.isBulkSending = false
        this.page.addCustomers.stats.added.count = this.page.addCustomers.stats.notAdded.count = 0
        this.showModal(false)
        this.getAddedInviteData()
        this.getReviewInvitesData()
        window.location.reload()
      })
    },
    /**
     * Handle removing all the data review invite queue
     * @return {void}
     */
    handleRemoveAllRecords () {
      axios.delete(`${this.org.id}/invites/remove-records`)
      .then(({data}) => {
        this.displaySuccessMsg(data.message, 'Successfully deleted all review invitations from invite queue')
      })
      .catch(() => {
        flash('Failed to delete invite data', 'is-danger')
      })
      .finally(() => {
        window.events.$emit('loadHeaderStats')
        this.page.addCustomers.stats.added.count = this.page.addCustomers.stats.notAdded.count = 0
        this.getAddedInviteData()
      })
    }
  },
  /**
   * Event before navigating to desired route
   * @param {object} to Route where user want to navigate
   * @param {object} from Route where is coming from navigation
   * @param {function} next Navigating towards the intended route if true
   * @return {void}
   */
  beforeRouteLeave (to, from, next) {
    // If user changed the form and is Enterprise/Pro user
    if ((this.accordion.reviewInvites.loader.isChanged || this.accordion.googleInvites.gmb.loader.isChanged) && this.userType) {
      this.modal_props = {
        title: 'Are you sure?',
        body: 'You have unsaved changes on this page. If you navigate away, your changes will be lost. ',
        btn_action_title: 'STAY ON THIS PAGE',
        secondary_btn_title: 'LEAVE PAGE',
        to_path: to.path,
        show_btns: true,
        task: 'deleteInvite'
      }
      // Fire off confirmation modal
      modal(this.modal_props)
    } else {
      next()
    }
  }
}
</script>

<style scoped>
/* Invite Template CSS Begins */
.has-spinner__spinner {
  max-width: 60px;
  width: 100%;
}
.label-header {
  color: #58595b;
  font-size: 12px;
  font-weight: 600;
  font-weight: bold;
}
.preview-button-color, .preview-button-color:hover{
  width: 30%;
  float: left;
  border: solid 1px #30aae1 !important;
  background-color: #ffffff;
}
.disable-field{
  color: #8a8c91 !important;
}
.input{
  color: #4a4a4a;
}
.invite-template .is-three-quarters, .invite-template .is-three-quarters+.column{
  padding-left: 0px;
}
.invite-template .is-three-quarters .input{
  height: 40px;
  width: 70%;
  float: left;
}
.has-text-danger{
  font-size: 0.9em;
}
input:focus, textarea:focus, select:focus {
  border-color: #b5b5b5;
}
.photo-row {
  line-height: 33px;
}
.photo-row-img {
  vertical-align: middle;
  margin-right: 10px
}
.photo-row-thumbnail {
  width: 40px;
  height: 40px;
  border: solid 1px #dbdbdb;
  background-color: #FFFFFF;
  border-radius: 50%;
}
.photo-row-remove {
  color: #30aae1;
  margin-top: 5px;
  margin-left: 10px;
  width: 45px;
  height: 17px;
  font-size: 12px;
}
.photo-upload-link {
  font-size: 12px;
  color: #30aae1;
}
.photo-name {
  font-size: 11px;
  color: #58595b;
}
.allow-photo {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  color: #707070;
}
.allow-photo-radio {
  color: #707070;
  font-size: 12px;
  padding: 7px;
}
.tooltip {
  position: absolute;
  left: 115px
}
.tooltip-submission a.tooltip {
  display: inline-block;
  position: absolute;
  left: 110px;
}
.tooltip-logo label a.tooltip {
  display: inline-block;
  position: absolute;
  left: 40px;
}
.tooltip-header label a.tooltip {
  display: inline-block;
  position: absolute;
  left: 90px;
}
.tooltip .tooltiptext {
  visibility: hidden;
  background-color: #f3f3f4;
  color: #fff;
  border-radius: 0px;
  min-height:80px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  top:-37px;
  left: 110px;
  margin-left: -66px;
  opacity: 0;
  transition: opacity 0.3s;
  padding-right: 50px;
}
.tooltip .tooltiptext p {
  width: 180px;
  font-size: 10px;
  font-weight: normal;
  color: #707070;
  padding: 10px 20px;
  text-align: justify;
}
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 30%;
  left: -1px;
  margin-left: -19px;
  border-width:10px;
  border-style: solid;
  border-bottom: 10px solid #f3f3f4;
  transform: rotate(270deg);
}
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.tooltiptext.submission-type {
  width: 350px !important;
  height: 232px !important;
  background-color: #f3f3f4;
}
.submission-type.tooltiptext p {;
  width: 308px;
  height: 165px;
  font-weight: normal;
  line-height: 1.55;
  font-size: 11px;
  color: #707070;
}
.right-section.column.preview {
  background-image: url("/static/img/review_images/mask-group-34.png");
  padding: 0;
  height: 689px;
  background-size: cover;
}
.review-left-box {
  padding-right: 25px;
}
.preview-header {
  background-color: #f3f3f4;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 27px;
  width: 100%;
}
.save-button {
  width: 130px;
  height: 35px;
}
.tooltip-submission {
  position: relative;
}
.tooltip-logo {
  position: relative;
}
.tooltip-header {
  position: relative;
}
.email-validation {
  margin-top: -17px;
}
.free-biz-fa-lock {
  float: right;
  margin-top: -17px;
  margin-right: 12px;
  color: #cbcbd2;
}
.review-invite-info-box {
  margin-top: -15px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  color: #707070;
}
.email-horizontal-row {
  margin-left: -13px;
  margin-right: -13px;
  margin-top: 9px;
}
.free-biz-offer-info {
  text-align: center;
  margin-bottom: 27px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  color: #707070;
}
.free-biz-offer-info a {
  text-decoration: underline;
  color: #30aae1;
}
.free-biz-offer-info a:hover {
  color: #30aae1;
}
.input {
  height: 3.25em !important;
  font-size: 12px;
  color: #707070;
}
.invite-body-textarea {
  height: 3.25em !important;
  font-size: 12px !important;
  color: #707070;
}
.email-customisation-font {
  font-size: 14px;
}
.left-section-box {
  width: 47%;
}
@media  screen and (max-width: 767px) {
  .left-section-box {
    width: 100% !important;
  }
  .right-section.column.preview {
    width: 100% !important;
  }
}
/**/
</style>
<style scoped>
.desktop-icon {
  width: 45px;
  display: flex;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
}
span.desktop-icon.active .ds1 {
  display: block;
}
span.desktop-icon.active .ds2 {
  display: none;
}
span.desktop-icon .ds2 {
  display: block;
}
span.desktop-icon .ds1 {
  display: none;
}
.mob-icon {
  width: 45px;
  display: flex;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  padding: 9px;
}
.mob-icon.active .mb1 {
  display: block;
}
.mob-icon.active .mb2 {
  display: none;
}
.mob-icon .mb1 {
  display: none;
}
span.mob-icon.active,span.desktop-icon.active {
  background: #909ea9;
}
span.desktop-icon,span.mob-icon {
  background: #fff;
}
.preview-mobile-desktop-icon {
  display: flex;
  float: right;
  margin-right: 23px;
  margin-top: -6px;
  height: 36px;
}
.preview-mobile-desktop-icon .preview-toggle-icons {
  display: inline-flex;
  border: 2px solid #d3d3d3;
  border-radius: 2px;
}
.allow-photo-ul {
  margin-left: -7px;
}
</style>
<style>
.invite-template {
  margin-top: 28px;
}
.left-section{
  padding-left: 0;
}
.add-tag {
  cursor: pointer;
}
.tags li {
  padding: 5px;
  background-color: rgba(138, 140, 145, 0.1);
  color: #868282;
}
.disable-field{
  pointer-events: none;
}
.right-section {
  max-width: 100%;
}
.left-email-box {
  border: 1px solid #CCCCCC;
  max-width: 100%;
  margin-top: 15px;
}
iframe {
  max-width: 100%;
  margin: 0px auto;
  display: block;
  padding: 0 25px;
}
.responsive-action{
  text-align: center;
  margin-bottom: 10px;
}
.responsive-action span{
  cursor: pointer;
}
.has-margin-top-1{
  margin-top: 3px;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
}

/*New CSS Begins*/
.look-and-feel-section .description {
  color: #58595b;
  margin: 0 0 20px 0;
  font-size: 12px;
}
.section-divider {
  margin: 5px 0 12px 0;
}
.upgrade-text {
  color: #58595b;
  font-size: 12px;
}
.upgrade-text .upgrade-word {
  color: #30aae1;
  text-decoration: underline;
}
/*New CSS Ends*/
</style>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.email-and-sms-section {
  .button {
    height: 35px;
    width: 135px;
  }
  .disabled {
    color: #58595b !important;
    opacity: 0.5;
  }
  .input[disabled], textarea[disabled] {
    color: $text-color !important;
    border: solid 1px rgba(88,89,91,0.32) !important;
    opacity: 0.4;
    background-color: #ffffff !important;
  }
  .upgrade-section {
    font-size: 12px;
    font-weight: normal;

    .upgrade-text {
      color: #30aae1;
      text-decoration: underline;
    }
  }
  .text-section {
    .heading-text {
      color: $blue-text-color;
      font-size: 14px;
      font-family: Montserrat;
      font-weight: bold;
    }
    .description {
      color: #707070;
      font-size: 12px;
    }
    .customer-section {
      margin: 25px 0;

      .data-section {
        color: #707070;
        font-size: 11px;

        .is-success {
          color: #17be86;
        }
        .is-danger {
          color: #d51f1f;
        }
      }
      .add-individual-customer-section {
        top: 80%;
        z-index: 1;
        width: 330px;
        position: absolute;
        background: #ffffff;
        border-top: 5px solid #1261a0;
        box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.16);

        .label-text {
          color: $text-color;
          font-size: 12px;
          font-weight: bold;
        }
        input {
          color: #707070;
          padding: 5px;
          border: solid 1px #dbdbdb;
        }
        .optional-text {
          color: $text-color;
          font-size: 12px;
          font-weight: normal;
        }
      }
      .upgrade-section {
        margin: 0 0 20px;
        background-color: #fcfcfc;

        .text {
          color: $text-color;
          font-size: 12px;
          font-weight: bold;;
        }
        .message {
          color: $text-color;
          font-size: 12px;
          background-color: unset;
          border-radius: unset;
        }
        .invite-package-count-row {
          padding: 0 20px;

          .invite-package-count {
            border: solid 1px rgba(88, 89, 91, 0.32);

            .column {
              display: flex;
              padding: 8px 25px;
              align-items: center;

              &:first-child {
                color: rgba(88, 89, 91, 0.4);
                border-right: solid 1px rgba(88, 89, 91, 0.32);
              }
            }
          }
          &>>>.input-row {
            margin: 14px 0px 0px 30px;
          }
        }
      }
      .send-invites-button[disabled] {
        color: #fff;
        background-color: #CDCBCB;
        border: 1px solid #CDCBCB;

        &:hover {
          border: 1px solid #CDCBCB;
        }
      }
    }
    .action-button {
      color: #1261A0;
      height: 25px;
      border: 1px solid #1261A0;
      cursor: pointer;
      font-size: 12px;
      min-width: 130px;
      background-color: #FFFFFF;
    }
    .update-class-text {
      color: $blue-text-color;
      font-size: 14px;
      font-family: Montserrat;
      font-weight: bold;
    }
    .review-invite-section {
      margin: 12px 0 0 0;
      border-top: solid 1px rgba(88,89,91,0.32);
    }
    .disabled-section {
      cursor: not-allowed;
      opacity: 0.4;
      pointer-events: none;
      background-color: #ffffff;
    }
    .review-invite-section, .google-invite-section {
      cursor: pointer;
      border-bottom: solid 1px rgba(88,89,91,0.32);

      .setting-text {
        color: #707070;
        font-size: 12px;

        a {
          color: $light-blue-color;
          text-decoration: underline;
        }
      }
      .section-title {
        color: $text-color;
        font-size: 12px;
        font-weight: 600;
      }
      &.padding-bottom {
        padding-bottom: 30px;
      }
      .email-section {
        padding-bottom: 25px;
        margin-bottom: 10px;
        border-bottom: solid 1px rgba(88, 89, 91, 0.32);

        &>>>.input {
          height: 35px !important;
        }
        &>>>.tooltip .tooltiptext {
          top: -70px;
        }
        .dropdown-with-arrow i {
          position: absolute;
          font-size: 1.4rem;
          color: transparent;
          border: 1px solid #95979b;
          border-right: 0;
          border-top: 0;
          content: " ";
          display: block;
          height: 0.5em;
          pointer-events: none;
          -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
          -webkit-transform-origin: center;
          transform-origin: center;
          width: 0.5em;
          margin-top: -0.375em;
          right: 1.125em;
          top: 70%;
        }
        .dropdown-with-arrow i:before {
          border: 0px;
        }
      }
      .sms-section {
        font-size: 12px;
        color: #707070;
        outline: none;
        box-shadow: none;

        textarea {
          resize: none;
          color: #707070;
          font-size: 12px;
          padding: 12px;
        }
        .limit-160-characters {
          color: #58595b;
          right: 0;
          width: 195px;
          height: 14px;
          bottom: 5px;
          opacity: 0.6;
          font-size: 10px;
          position: absolute;
        }
        .email-actions {
          width: 130px;
          height: 35px;

          &.grey-button {
            color: #ffffff;
            background-color: #cdcbcb;

            &:hover {
              background-color: #8a8c91;
            }
          }
        }
      }
      input[type=text] {
        height: 35px !important;
      }
    }

    .google-invite-section {
      .distribution-section {
        padding-bottom: 30px;
        border-bottom: solid 1px rgba(88,89,91,0.32);

        .distribution-text {
          color: #3b3c3d;
          font-size: 12px;

          .percentage {
            color: #58595b;
            font-weight: bold;
            font-size: 14px;
          }
        }
      }
      .has-text-underlined {
        color: #30aae1;
        font-size: 12px;
      }
      .email-section {
        padding-bottom: 12px;
        border-bottom: none;
      }
      .grey-button {
        color: #ffffff;
        background-color: #cdcbcb;

        &:hover {
          background-color: #8a8c91;
        }
      }
      .invite-template {
        margin-top: 0;
      }
    }
  }
  .cursor-not-allowed {
    cursor: not-allowed
  }
}
.allow-photo-ul {
  input[type="radio"] {
    &:disabled {
      border: 1px solid #c9cbdb;    
      background-color: #c9cbdb;
    }
  }
}
.error {
  color: #E8441F;
  font-size: 12px;
}
.modal {
  &>>>.modal-card {
    height: 425px;
    width: 450px !important;

    .modal-card-title {
      font-size: 16px;
    }
    .modal-card-body {
      font-size: 12px;
      text-align: left !important;

      .accept-section {
        align-items: flex-end;

        .checkbox {
          margin-top: 1%;
        }
      }
    }
    .modal-card-foot {
      padding-top: 0;

      .button {
        height: 35px;
        width: 135px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/collect-reviews/email-and-sms-invites/EmailAndSMS.vue